import {create} from "zustand";
import {derivedRemoteStore} from "./DerivedStore";
import {KeyHistoryRecord, KeySnapshot} from "./Model";
import {useKeyDataStore} from "./KeyDataStore";
import {mapNotNull} from "../util/ArrayUtil";
import {combineCmp, stringCmp} from "../util/SortUtil";

export type KeySnapshotUpdate = KeySnapshot & {
    historyRecord: {
        updatedAt: string
    },
};

export const useKeyHistoryLastUpdatesStore = create(
    derivedRemoteStore(
        {keyData: useKeyDataStore},
        ({keyData}) => keyData
            .flatMap(key =>
                mapNotNull<KeyHistoryRecord, KeySnapshotUpdate | null>(key.history, historyRecord => {
                    return historyRecord.updatedAt ? {
                        key,
                        historyRecord,
                    } as KeySnapshotUpdate : null;
                })
            )
            .sort(combineCmp(
                stringCmp(it => it.historyRecord.updatedAt, true),
                stringCmp(it => it.historyRecord.to ?? '9999-12-31', true),
            )),
    )
);
